module.exports = "/assets/data/553e814c112e2c332874c32f4c38d0ae-S1.data.json";